import styled from 'styled-components';
export const ModalTitle = styled.div`
    color: #121212;
    font-size: 20px;
    font-weight: 600;
    line-height: 28px;
    margin-top: 16px;
    margin-left: 4px;
    margin-bottom: 16px;
    letter-spacing: -0.1px;
    flex: 1 0 0;
`;

export const SecondaryActionText = styled.div`
    text-align: center;
    display: block;
    padding: 16px 0 4px;
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: #1c73e8;
    cursor: pointer;
`;

export const IconContainer = styled.div`
    width: 72px;
    height: 72px;
`;
